import { render } from "./servicesEN.vue?vue&type=template&id=a83e05fe&scoped=true"
import script from "./servicesEN.vue?vue&type=script&lang=js"
export * from "./servicesEN.vue?vue&type=script&lang=js"

import "./servicesEN.vue?vue&type=style&index=0&id=a83e05fe&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a83e05fe"]])

export default __exports__